__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/21971f1383a9f065601f829280696a27a9411df3/_next/";